import React from 'react'

import Layout from '@/components/layout'
import SEO from '@/components/seo'
import HomeBody from '@/components/home'
const IndexPage = () => (
  <Layout>
    <SEO
      title="Spring Internship 2019"
      keywords={[
        `dwarves foundation`,
        'software',
        'engineer',
        `internship`,
        `career`,
        `2019`,
      ]}
    />
    <HomeBody />
  </Layout>
)

export default IndexPage
